import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
import ReactLoader from '../../components/ReactLoader';
import { CartContext } from '../../context/CartContext';
import Swal from 'sweetalert2';
const config = require('../../config.json')


export default function Cart({ ipAddress, loginData }) {
    const { cart } = useContext(CartContext)

    const { removeFromCart } = useContext(CartContext)
    const { totalBV } = useContext(CartContext)
    const { totalMRP } = useContext(CartContext)
    const { totalDP } = useContext(CartContext)
    const { emptyCart } = useContext(CartContext)
    const { cartDetails } = useContext(CartContext)
    const [loading, setLoading] = useContext(LoadingContext)

    const [bal, setBal] = useState(0)

    const handleCheckout = () => {
        if (bal?.topup >= totalDP) {
            if (totalDP > 0) {
                if (cart.length > 0) {
                    setLoading(true)
                    let data = JSON.stringify({
                        "ip": ipAddress,
                        "ulid": loginData.ulid.Cart,
                        "totalBv": totalBV,
                        "totalDp": totalDP,
                        "totalMrp": totalMRP,
                        "cartDetails": cartDetails
                    });
                    let axiosConfig = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: `${config.baseUrl}productbuy`,
                        headers: {
                            'ip': ipAddress,
                            'ulid': loginData.ulid,
                            'auth': loginData.auth,
                            'token': loginData.token,
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    // console.log(axiosConfig)
                    axios.request(axiosConfig)
                        .then((response) => {
                            setLoading(false)
                            Swal.fire({
                                icon: 'success',
                                title: 'AD Herbal',
                                text: response.data?.message
                            })
                            emptyCart()
                            console.log(response.data)
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            }
        }
    }
    const handleInfo = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}wallet`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                console.log(response.data)
                setBal(response.data?.info?.wallet)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])

    useEffect(() => {

        handleInfo()
    }, [handleInfo])
    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    {loading ? <><ReactLoader /></> :
                        <div className="content-wrapper mb-4">
                            <div className="container-xxl flex-grow-1 container-p-y pt-2">
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12  mb-2">
                                            <div className="card">
                                                <div className="card-header align-items-center ">
                                                    <div className="card-title mb-0">
                                                        <h6 className="m-0 text-center text-black ">Cart by AD Herbal</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row '>
                                        <div className='col-md-12  mb-2 '>
                                            <div className="card mb-2">
                                                <div className="card-header d-flex align-items-center justify-content-between p-1">
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless">
                                                            <tbody>
                                                                {
                                                                    cart.length > 0 ? cart.map((list, index) => {

                                                                        return (
                                                                            <>
                                                                                <tr key={index + 101} style={{ borderTop: '1px solid black' }}>
                                                                                    <td>
                                                                                        <div className="d-flex justify-content-start align-items-center">
                                                                                            <div className="avatar me-1">
                                                                                                <img src={list?.link} alt="Avatar" className="rounded-circle" height={"50px"} />
                                                                                            </div>
                                                                                            <div className="d-flex flex-column">
                                                                                                <h6 className="mb-0 text-sm text-black">{list?.product_name}</h6>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td><span className='text-sm text-black'>MRP:{list.product_mrp * list.quantity}</span></td>
                                                                                    <td><span className='text-sm text-black'>DP:{list.product_dp * list.quantity}</span></td>
                                                                                </tr>
                                                                                <tr key={index + 1002} style={{ borderTop: '1px solid black' }}>
                                                                                    <td><span className='text-sm text-black'>BV:{list.product_bv * list.quantity}</span></td>
                                                                                    <td><span className='text-sm text-black'>Quantity:{list.quantity}</span></td>
                                                                                    <td><button className='btn btn-xs btn-danger' onClick={() => removeFromCart(list.id, list.quantity)}>X</button></td>

                                                                                </tr>
                                                                            </>
                                                                        )
                                                                    }) : <tr><td className='text-sm'>NO PRODUCT IN CART</td></tr>}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <th className='text-sm'>
                                                                        Total MRP : {totalMRP}
                                                                    </th >
                                                                    <th className='text-sm'>
                                                                        Total DP : {totalDP}
                                                                    </th>
                                                                </tr>
                                                                <tr>
                                                                    <th className='text-sm'>
                                                                        Total BV : {totalBV}
                                                                    </th>
                                                                    <th className='text-sm'>
                                                                        Balance : {bal?.topup}
                                                                    </th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="card mt-2">
                                                    <div className="card-header">
                                                        <div className='row'>
                                                            <div className='col-md-12 text-center'>
                                                                {(bal?.topup >= totalDP) ? <button className='btn btn-info btn-sm' onClick={handleCheckout}>Checkout</button> : <button className='btn btn-danger btn-sm'>Insufficient Balance</button>}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>}
                </div>
            </div>

        </>
    );
}